module.exports = __webpack_public_path__ + "assets/images/player2.59cfcffbe20c887c2b778d88ccd41233.svg";